import { IQuantity, Quantity } from "../../../../common/models/quantity.model";
import i18next from "i18next";

export const generateValidators = (quantity: IQuantity, actions: any, selectedValidator?: any) => {
  const t = i18next.getFixedT(null, "admin");

  const notChecked = [{
    key: "startCheck",
    text: t("validators.commands.check") as string,
    iconProps: { iconName: "textDocument" },
    name: "startCheck",
    onClick: actions.openPanel,
  }]

  const approveValidator = [{
    key: "confirm",
    text: t("validators.commands.confirm") as string,
    iconProps: { iconName: "textDocument" },
    name: "confirtm",
    onClick: actions.openPanelSyncValidator,
    disabled: selectedValidator && selectedValidator.approvedDate ? true : false
  }]

  switch (quantity) {
    case Quantity.NONE:
      return [...notChecked];
    case Quantity.ONE:
      return [...approveValidator];
    case Quantity.MANY:
      return [];
  }
};